import { Link } from 'react-router-dom'
import { useLang } from '../utils/hooks'
import { langHeader } from '../assets/langHeader'

const Footer = () => {
  const { lang } = useLang()
  const choosenLang = lang === 'eng' ? langHeader.eng : langHeader.fr
  return (
    <footer className="footer has-background-white mt-auto pt-4 pb-6">
      <div className="level">
        <div className="level-item">
          <h4 className="has-text-grey-light">
            <strong>WSurf</strong>{' '}
            <a
              href="https://www.fkwave.com"
              target="_blank"
              rel="noreferrer"
              className="has-text-link"
            >
              © fkw
            </a>
          </h4>
        </div>

        <div className="level-item">
          <p className="has-text-info">
            {choosenLang.license}{' '}
            <a
              rel="noreferrer"
              href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
              target="_blank"
              className="has-text-link"
            >
              CC BY-NC-SA 4.0
            </a>
          </p>
        </div>
        <div className="level-item">
          <div className="has-text-grey-light">
            <a
              href="mailto:wsurf@fkwave.com"
              target="_blank"
              rel="noreferrer"
              className="has-text-link"
            >
              Contact{' '}
            </a>
          </div>
        </div>
        <div className="level-item">
          <Link className="has-text-link" to="/cgu">
            {choosenLang.cgu}
          </Link>
        </div>

        <div className="level-right">
          <div className="level-item">
            <a href="https://bulma.io" target="_blank" rel="noreferrer">
              <img
                src="https://bulma.io/assets/images/made-with-bulma.png"
                alt="Made with Bulma"
                width="128"
                height="24"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
